// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"ve","flipped":"we","mainContentCtaDefault":"xe","disabled":"ye","mainContentCtaWhite":"ze"};